<template>
	<div class="col-12 pl-4 pr-4 text-center">
		<div class="row">
			<div class="col-12 mt-3 mb-3">
				<h4 class="text-purple mt-4 mb-3 font-size-16">MASUK</h4>
			</div>
		</div>
		<form role="form" v-on:submit.prevent="onLogin">
			<div class="row">
				<div class="col-12 col-md-10 offset-md-1">
					<ml-alert v-for="alert in this.alerts" :key="alert.id" :type="alert.type" :message="alert.message" @close="removeAlert(alert.id)" close/>
					<img src="/assets/icon/profile_login.png" class="position-absolute img-login"><input type="text" v-uppercase="username" name="" placeholder="Kode Member" class="form-control font-size-11 no-border cus-box-shadow text-gray box-purple pl-5 pr-5 f-lato" v-model="username">
					<div class="invalid-feedback d-block text-left" v-if="this.fieldErrors.username">Kode Member {{ this.fieldErrors.username }} </div>
				</div>
			</div>
			<div class="row">
				<div class="col-12 col-md-10 offset-md-1 pt-4">
					<img src="/assets/icon/lock_login.png" class="position-absolute img-login"><input type="password" name="" placeholder="Kata Sandi" class="form-control font-size-11 no-border cus-box-shadow text-gray box-purple pl-5 pr-5 f-lato" id="in-password" v-model="password">
					<span @click="showPassword" class="text-right position-absolute cursor-pointer icon-password">
						<span v-show="sPassword"><i class="far fa-eye"></i></span>
						<span v-show="!sPassword"><i class="far fa-eye-slash"></i></span>
					</span>
					<div class="invalid-feedback d-block text-left" v-if="this.fieldErrors.password">Kata Sandi {{ this.fieldErrors.password }} </div>
				</div>
			</div>
			<div class="row" v-if="showRegister">
				<div class="col-12 text-left col-md-10 offset-md-1 pt-2 font-size-11 font-size-sm-10" v-if="false">
					Belum terdaftar menjadi Mitra? <a class="text-purple" href="javascript:;" @click="register" > Daftar Disini</a>
				</div>
			</div>
			<div class="row">
				<div class="col-12 pt-2 mt-2">
					<div class="row">
						<div class="col-8 offset-2 col-md-6 offset-md-3 mt-4 pb-5">
							<button type="submit" class="btn btn-mila btn-block text-white box-purple" :disabled="isAttempting"><img src="/assets/icon/login.png" class="img-fluid pr-2">MASUK</button>
						</div>
					</div>
				</div>
			</div>
		</form>
	</div>
</template>
<script>

import { createNamespacedHelpers } from 'vuex';

const { mapState, mapMutations, mapActions } = createNamespacedHelpers('auth');
export default {
	name:"LoginComponent",
	data() {
		return {
			username: '',
			password: '',
			sPassword: true,
		}
	},
	props: {
		showRegister: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		...mapState(['isAttempting', 'fieldErrors', 'alerts']),
	},
	methods: {
		...mapMutations(['removeAlert', 'reset']),
		...mapActions(['login']),

		register() {
			this.$emit('register')
		},
		onLogin() {
			this.login({ username: this.username, password: this.password }).then(() => {
				const { redirect } = this.$route.query;

				if (redirect) {
					this.$router.push(redirect);
				} else if(this.$route.name=="cart"){
					this.$router.go()
				} else {
					this.$router.push({ name: 'home' });
				}
			});
		},
		showPassword() {
			var x = document.getElementById("in-password");
			if (x.type === "password") {
				x.type = "text"
				this.sPassword = false
			} else {
				x.type = "password"
				this.sPassword = true
			}
		},
	},
}
</script>
<style scoped>
a:hover {
	color: #c96dd8;
	text-decoration: none;
}
a:focus {
	box-shadow: none !important;
}
.form-control::placeholder {
	color: #636e72;
}
.text-purple {
	color: #7C1CC6;
}
.cus-box-shadow {
	box-shadow: 0px 0px 6px 1px #dfe6e9;
}
.box-shadow {
	box-shadow: 0px 0px 10px .1px #7f7f7f;
}
.box-purple:focus {
	border-color: #daa3e3;
	box-shadow: 0px 0px 1px 3px #daa3e3;
}
.text-gray {
	color: #333333;
}
.no-border {
	border: none;
}
.btn-mila {
	background-image: linear-gradient(to right, #7C1CC6, #460C94);
	color: #fff;
}
.btn {
	font-size: 1rem !important;
}
.img-login {
	left: 2rem;
	margin-top: 9px;
	-webkit-filter: grayscale(100%) brightness(110%) contrast(0.9);
	filter: grayscale(100%) brightness(110%) contrast(0.9);
	z-index: 100;
}
</style>
